var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-max"},[_c('BaseText',{staticClass:"text-text-muted py-3 px-3",attrs:{"type":"body","size":"sm"}},[_vm._v(" "+_vm._s(_vm.formattedDateRange)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }